// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"e9d6ef48","986":"08f6a2e6"}[chunkId] + ".chunk.js";
};